import React, { useEffect, useState } from 'react';
import api from '../api';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function RefundPage() {
  const [customers, setCustomers] = useState([]);
  const [refunds, setRefunds] = useState([]);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    CustomerID: '',
    RefundAmount: '',
    RefundDate: new Date().toISOString().substr(0, 10),
    PaymentMode: 'Cash',
    Remarks: ''
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const custRes = await api.get('/customers');
    setCustomers(
      custRes.data.map(c => ({
        label: `${c.Name} (${c.GSTIN || 'No GSTIN'})`,
        value: c.CustomerID
      }))
    );

    const refundRes = await api.get('/refunds');
    setRefunds(refundRes.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.CustomerID || !form.RefundAmount) return toast.error('All fields required');
    await api.post('/refunds', form);
    toast.success('Refund saved');
    setForm({ ...form, RefundAmount: '', Remarks: '' });
    loadData();
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">Customer Refund</h4>
        <button className="btn btn-secondary" onClick={() => navigate('/dashboard')}>
          ← Back to Dashboard
        </button>
      </div>

      <form className="row g-3 mb-4" onSubmit={handleSubmit}>
        <div className="col-md-6">
          <label className="form-label">Select Customer</label>
          <Select
            options={customers}
            onChange={(option) => setForm({ ...form, CustomerID: option?.value })}
            placeholder="Search by name or GSTIN"
            isClearable
          />
        </div>

        <div className="col-md-3">
          <label className="form-label">Amount</label>
          <input
            type="number"
            className="form-control"
            value={form.RefundAmount}
            onChange={(e) => setForm({ ...form, RefundAmount: e.target.value })}
            required
          />
        </div>

        <div className="col-md-3">
          <label className="form-label">Date</label>
          <input
            type="date"
            className="form-control"
            value={form.RefundDate}
            onChange={(e) => setForm({ ...form, RefundDate: e.target.value })}
            required
          />
        </div>

        <div className="col-md-3">
          <label className="form-label">Mode</label>
          <select
            className="form-select"
            value={form.PaymentMode}
            onChange={(e) => setForm({ ...form, PaymentMode: e.target.value })}
          >
            <option value="Cash">Cash</option>
            <option value="UPI">UPI</option>
            <option value="Bank">Bank</option>
          </select>
        </div>

        <div className="col-md-6">
          <label className="form-label">Remarks</label>
          <input
            type="text"
            className="form-control"
            value={form.Remarks}
            onChange={(e) => setForm({ ...form, Remarks: e.target.value })}
          />
        </div>

        <div className="col-12">
          <button className="btn btn-primary">Save Refund</button>
        </div>
      </form>

      <h5 className="mb-3">Refund History</h5>
      <div className="table-responsive">
        <table className="table table-bordered table-sm">
          <thead className="table-light">
            <tr>
              <th>Date</th>
              <th>Customer</th>
              <th>Amount</th>
              <th>Mode</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {refunds.map(r => (
              <tr key={r.RefundID}>
                <td>{new Date(r.RefundDate).toLocaleDateString()}</td>
                <td>{r.CustomerName}</td>
                <td>₹{parseFloat(r.RefundAmount).toFixed(2)}</td>
                <td>{r.PaymentMode}</td>
                <td>{r.Remarks}</td>
              </tr>
            ))}
            {refunds.length === 0 && (
              <tr><td colSpan="5" className="text-center text-muted">No refunds recorded</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
